import { pendoService } from "@/services/pendo/Pendo";
import rumService, { RUM_EVENT_TYPES, RumEventType } from "@/utils/awsRUM/awsRUM";

interface TrackRyteEventOptions {
  eventName: string;
  rumType?: RumEventType;
  message: string;
  data?: Record<string, unknown>;
}

/**
 * Tracks a RYTE event in both Pendo and RUM in a single call.
 * Keeps the two services in sync and reduces boilerplate in handlers.
 */
export const trackRyteEvent = ({
  eventName,
  rumType = RUM_EVENT_TYPES.USER_ACTION,
  message,
  data,
}: TrackRyteEventOptions): void => {
  pendoService.trackEvent(eventName, data);
  rumService.customEvent({ type: rumType, message, data });
};
